import { type ServerResponse, axios } from '~/axios'

export interface SurveyDefinition {
  id: number
  title: string
}

/**
 * Fetches all available survey definitions for a family
 * @param familyId - The numeric ID of the family
 * @returns Array of survey definitions
 */
export async function getSurveyDefinitionsByFamilyId(familyId: number) {
  const query = /* GraphQL */ `
    query surveyDefinitionsByFamily($family: Long) {
      surveysDefinitionByFamily(family: $family) {
        id
        title
      }
    }
  `

  return await axios.post<
    ServerResponse<{
      surveysDefinitionByFamily: SurveyDefinition[]
    }>
  >('/graphql', {
    query,
    variables: { family: familyId },
  })
}
